import { Logger } from "@client/helpers";
import { Async } from "@core/helpers";
import { AppSettings, AppSettingsDefault } from "@core/models";
import { createContext, PropsWithChildren, useContext, useEffect, useState } from "react";
import BusyBox from "../components/BusyBox";
import FuzionLoader from "../components/FuzionLoader";

type AppState = {
    settings: AppSettings;
};
const AppContext = createContext({
    state: {
        settings: AppSettingsDefault,
    } as AppState,
    actions: {
        update(_newState: Partial<AppState>) {
            // Update the context state
        }
    }
});

type AppContextProviderProps = PropsWithChildren<{}>;
export default function AppContextProvider({ children }: AppContextProviderProps) {
    const [state, setState] = useState<AppState>({ settings: AppSettingsDefault });
    const [busy, setBusy] = useState(true);

    useEffect(() => {
        Async(async () => {
            // Fetch settings from API
            Logger.log("Fetching settings...");
            const response = await fetch("/apis/settings");
            Logger.log("Fetch response received...", response);
            if (response.status === 200) {
                const settings = await response.json();
                Logger.log("Fetched settings:", settings);
                // Update context state with fetched settings
                setState((prevState) => ({ ...prevState, settings }));
            }
        }).finally(() => {
            setBusy(false);
        });
    }, []);
    return (
        <AppContext.Provider value={{
            state,
            actions: {
                update(newState: Partial<AppState>) {
                    setState((prevState) => ({ ...prevState, ...newState }));
                }
            }
        }}>
            <BusyBox busy={busy} slots={{ loader: <FuzionLoader children="Initializing..." /> }}>
                {children}
            </BusyBox>
        </AppContext.Provider>
    );
}

export function useAppContext() {
    return useContext(AppContext);
}
export function useAppSettings() {
    const { state: { settings } } = useAppContext();
    return settings;
}